import { rankingItems } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/8 via-transparent to-accent-500/8 pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-accent-500/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full bg-primary-500/5 blur-3xl pointer-events-none"></div>

      <div className="section-container relative z-10 py-24 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left content */}
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时热度更新中
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
              每日黑料
              <span className="block text-primary-500 mt-1 md:mt-2">全网黑料排行榜与吃瓜大赛评选平台</span>
            </h1>

            <p className="mt-5 md:mt-6 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              每日黑料大赛热门排行榜为你汇集全网最具争议的黑料评选与实时吃瓜PK热度数据。
              从娱乐圈深扒到商圈内幕，从网红翻车到豪门恩怨——
              我们通过5分钟级更新的热度算法，让你一手掌握最全最深最热的吃瓜资讯。
            </p>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              当前赛季已收录黑料话题超<span className="font-bold text-primary-500">8,000条</span>，
              日均新增讨论<span className="font-bold text-primary-500">300+条</span>，吃瓜群众遍布全国。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mt-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活吃瓜群众</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">8,000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录黑料话题</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">5分钟</div>
                <div className="text-xs text-foreground-500 mt-1">热度刷新间隔</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a href="#ranking" className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                查看今日排行榜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a href="#cards" className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                浏览深度爆料
                <i className="ri-article-line"></i>
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              {/* Main hero image */}
              <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20newsroom%20with%20warm%20red%20and%20amber%20glowing%20screens%20showing%20breaking%20news%2C%20mysterious%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20no%20text%20on%20screens%2C%20warm%20contrast%20lighting&width=900&height=675&seq=hero-main&orientation=landscape"
                  alt="每日黑料今日热门话题"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Floating hot card */}
              <div className="absolute -bottom-3 -left-3 md:-bottom-5 md:-left-5 bg-background-50 rounded-xl px-4 py-3 shadow-sm border border-background-200/70">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                  <span className="text-xs font-semibold text-foreground-800 whitespace-nowrap">今日最热话题</span>
                </div>
                <p className="text-xs text-foreground-600 mt-1 max-w-[180px] truncate">
                  {rankingItems[0]?.title || '实时更新中'}
                </p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-primary-500 font-bold">{rankingItems[0]?.heat || '---'}</span>
                  <span className="text-xs text-foreground-400">{rankingItems[0]?.time || ''}</span>
                </div>
              </div>

              {/* Decorative element */}
              <div className="absolute -top-3 -right-3 md:-top-5 md:-right-5 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-accent-500/15 flex items-center justify-center">
                <i className="ri-fire-fill text-accent-500 text-2xl md:text-3xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient transition */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-b from-transparent to-background-50 pointer-events-none"></div>
    </section>
  );
}